import React from 'react';
import PropTypes from 'prop-types';
// import Spinner from 'components/shared/Spinner';
import DatePicker from 'components/ReservationPage/DatePicker';
import DatePickerMobile from 'components/ReservationPage/DatePickerMobile';
import ClassCard from 'components/shared/LessonCard/ClassCardNew';
import { formattedClass } from 'components/HomePage/ClassList/service';
import { CalendarCard } from './CalendarCard';
import styles from './styles.module.css';
import { CircularProgress } from '@material-ui/core';

export const ClassesContent = ({
  datesRange,
  targetDate,
  setTargetDate,
  isMobile,
  classes,
  isRequesting,
  loadClubsIsRequesting,
  clubs,
}) => {
  const setSelectDate = dayIndex => {
    if (targetDate.index !== dayIndex) {
      const selectedDate = datesRange.find(date => date.index === dayIndex);
      setTargetDate(selectedDate);
    }
  };

  return (
    <div className={styles.wrapper}>
      <div className={styles.datePickerWrapper}>
        {isMobile ? (
          <DatePickerMobile
            datesRange={datesRange}
            selectDate={setSelectDate}
            targetDate={targetDate}
          />
        ) : (
          <DatePicker
            datesRange={datesRange}
            selectDate={setSelectDate}
            targetDate={targetDate}
          />
        )}
      </div>
      <div
        className={`${styles.classesWrapper} ${
          (isRequesting && loadClubsIsRequesting && !clubs.length) || isRequesting
            ? styles.loading
            : null
        }`}
      >
        {(isRequesting && loadClubsIsRequesting && !clubs.length) || isRequesting ? (
          <CircularProgress size={60} style={{ color: '#FE5000' }} />
        ) : classes.length === 0 ? (
          <div className={styles.text}>no data</div>
        ) : (
          classes &&
          !isRequesting &&
          classes.map(item => {
            const info = formattedClass(item);
            return (
              <div className={styles.classesContainer} key={item.classId}>
                {isMobile ? (
                  <ClassCard {...info} {...item} />
                ) : (
                  <div>
                    <CalendarCard
                      groupEx={{
                        ...item,
                        note: info?.note,
                      }}
                    />
                  </div>
                )}
              </div>
            );
          })
        )}
      </div>
    </div>
  );
};

ClassesContent.propTypes = {
  datesRange: PropTypes.array,
  targetDate: PropTypes.object,
  setTargetDate: PropTypes.func.isRequired,
  isMobile: PropTypes.bool,
  classes: PropTypes.array,
  addClassToFavorite: PropTypes.func.isRequired,
  isRequesting: PropTypes.bool,
  removeClassFromFavorite: PropTypes.func.isRequired,
  isClassCallPopUpOpened: PropTypes.bool.isRequired,
  handleOpenClassCallPopUp: PropTypes.func.isRequired,
  user: PropTypes.object.isRequired,
};

ClassesContent.defaultProps = {
  datesRange: [],
  targetDate: {},
  isMobile: false,
  classes: [],
  isRequesting: null,
};
